import React, { useEffect } from "react";
import { Card, Accordion } from "react-bootstrap";

export default function Step8PleatedComponent({
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  step6,
  widthCart,
  step5,
  step3A0,
  step6A,
  setStep6A,
  setStep6,
  selectChanged,
  setExtendedTitle,
  extendedTitle,
  setDeps,
  setCart,
  inputs,
  pageLanguage,
  NextStep,
  modalHandleShow,
  setPanelSheerWarningTemp,
  setStep6BHead,
  step8B,
  setStep8,
  setHardwareNextStep,
  step6BHead,
  tracksList,
  step2A,
  step8,
  setStep6B,
  step6B,
  step6CHead,
  setStep6CHead,
  step6C,
  setStep6C,
  step8C,
  PopoverStickOnHover,
  popoverThumbnailHover,
  popoverImages,
  step2B,
  tracksList2,
  step2C,
  setPanelPLWarningTemp,
  step31,
  setStep6DHead,
  step6DHead,
  setStep6CHead9,
  step3,
  windowWidthPanelType,
}) {
  let isShow;
console.log(`windowWidthPanelType`, windowWidthPanelType);
  if (step3 === "true" && step31 === "true") {
    isShow = true;
  } else if (step3 === "true" && step31 === "Track") {
    isShow = true;
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) > 160) {
    isShow = true;
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    isShow = false;
  } else if (step3 === "false" && step31 === "" && parseInt(windowWidthPanelType) < 160) {
    isShow = false;
  } else if (step3 === "false" && step31 === "" && parseInt(windowWidthPanelType) > 160) {
    isShow = true;
  }
  let textDrapery;
  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery = t("Drapery Panel Single Panel");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery = t("Drapery Panel Single Panel");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Track"
  ) {
    textDrapery = t("Drapery Panel Track Single Panel");
  } else if (
    step3 === "true" &&
    step31 === "true" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else if (
    step3 === "true" &&
    step31 === "false" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else {
    textDrapery = t("Drapery Panel Track Single Panel");
  }

  let textDrapery2 = "";

  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery2 = t("Drapery Panel Single Panel, Right");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery2 = t("Drapery Panel Single Panel, Right");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Track"
  ) {
    textDrapery2 = t("Drapery Panel Track Single Panel, Right");
  } else if (
    step3 === "true" &&
    step31 === "true" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else if (
    step3 === "true" &&
    step31 === "false" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else {
    textDrapery2 = t("Drapery Panel Track Single Panel, Right");
  }

  let textDrapery3 = "";

  if (step3 === "true" && step31 === "true" && parseInt(windowWidthPanelType) < 160) {
    textDrapery3 = t("Drapery Panel Rod Pair, Split Draw");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery3 = t("Drapery Panel Pair, Split Draw");
  } else if (step6CHead === "Rod" && parseInt(windowWidthPanelType) > 160) {
    textDrapery3 = t("Drapery Panel Rod Pair, Split Draw");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery3 = t("Drapery Panel Pair, Split Draw");
  } else {
    textDrapery3 = t("Drapery Panel Track Pair, Split Draw");
  }

  let textSheer;
  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160 && step6BHead === "Rod") {
    textSheer = t("Rod Single Panel");
  } else if (
    step31 === "true" &&
    step3 === "true" &&
    parseInt(windowWidthPanelType) < 160 &&
    step6BHead === "Track"
  ) {
    textSheer = t("Track Single Panel");
  } else if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textSheer = t("Rod Single Panel");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textSheer = t("Single Panel");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textSheer = t("Single Panel");
  } else {
    textSheer = t("Track Single Panel");
  }

  let textSheer2 = "";

  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160 && step6BHead === "Rod") {
    textSheer2 = t("Rod Single Panel, Right");
  } else if (
    step31 === "true" &&
    step3 === "true" &&
    parseInt(windowWidthPanelType) < 160 &&
    step6BHead === "Track"
  ) {
    textSheer2 = t("Track Single Panel, Right");
  } else if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textSheer2 = t("Rod Single Panel, Right");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textSheer2 = t("Single Panel, Right");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textSheer2 = t("Single Panel, Right");
  } else {
    textSheer2 = t("Track Single Panel, Right");
  }

  let textSheer3 = "";

  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160 && step6BHead === "Rod") {
    textSheer3 = t("Rod Pair, Split Draw");
  } else if (
    step31 === "true" &&
    step3 === "true" &&
    parseInt(windowWidthPanelType) < 160 &&
    step6BHead === "Track"
  ) {
    textSheer3 = t("Track Pair, Split Draw");
  } else if (step3 === "true" && step31 === "true" && parseInt(windowWidthPanelType) < 160) {
    textSheer3 = t("Rod Pair, Split Draw");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textSheer3 = t("Pair, Split Draw");
  } else if (
    step3 === "true" &&
    step31 === "true" &&
    parseInt(windowWidthPanelType) > 160 &&
    step6BHead === "Track"
  ) {
    textSheer3 = t("Track Pair, Split Draw");
  } else if (step6BHead === "Rod" && parseInt(windowWidthPanelType) > 160) {
    textSheer3 = t("Rod Pair, Split Draw");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textSheer3 = t("Pair, Split Draw");
  } else {
    textSheer3 = t("Track Pair, Split Draw");
  }

  let textLayer;
  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160 && step6DHead === "Rod") {
    textLayer = t("Rod Single Panel");
  } else if (
    step31 === "true" &&
    step3 === "true" &&
    parseInt(windowWidthPanelType) < 160 &&
    step6DHead === "Track"
  ) {
    textLayer = t("Track Single Panel");
  } else if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textLayer = t("Rod Single Panel");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textLayer = t("Single Panel");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textLayer = t("Single Panel");
  } else {
    textLayer = t("Track Single Panel");
  }

  let textLayer2 = "";

  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160 && step6DHead === "Rod") {
    textLayer2 = t("Rod Single Panel, Right");
  } else if (
    step31 === "true" &&
    step3 === "true" &&
    parseInt(windowWidthPanelType) < 160 &&
    step6DHead === "Track"
  ) {
    textLayer2 = t("Track Single Panel, Right");
  } else if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textLayer2 = t("Rod Single Panel, Right");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textLayer2 = t("Single Panel, Right");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textLayer2 = t("Single Panel, Right");
  } else {
    textLayer2 = t("Track Single Panel, Right");
  }

  let textLayer3 = "";

  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160 && step6DHead === "Rod") {
    textLayer3 = t("Rod Pair, Split Draw");
  } else if (
    step31 === "true" &&
    step3 === "true" &&
    parseInt(windowWidthPanelType) < 160 &&
    step6DHead === "Track"
  ) {
    textLayer3 = t("Track Pair, Split Draw");
  } else if (step3 === "true" && step31 === "true" && parseInt(windowWidthPanelType) < 160) {
    textLayer3 = t("Rod Pair, Split Draw");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textLayer3 = t("Pair, Split Draw");
  } else if (
    step3 === "true" &&
    step31 === "true" &&
    parseInt(windowWidthPanelType) > 160 &&
    step6DHead === "Track"
  ) {
    textLayer3 = t("Track Pair, Split Draw");
  } else if (step6DHead === "Rod" && parseInt(windowWidthPanelType) > 160) {
    textLayer3 = t("Rod Pair, Split Draw");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textLayer3 = t("Pair, Split Draw");
  } else {
    textLayer3 = t("Track Pair, Split Draw");
  }

  useEffect(() => {
    if (widthCart === undefined) {
      let tempExtended = { ...extendedTitle };
      tempExtended["6"][0] = [];
      setExtendedTitle(tempExtended);
    }
  }, [widthCart]);

  useEffect(() => {
    let tempExtended = { ...extendedTitle };
    tempExtended["8"] = [];
    tempExtended["8A"] = [];
    tempExtended["8B"] = [];
    tempExtended["8C"] = [];
    setExtendedTitle(tempExtended);
  }, [step6CHead]);

  // Privacy header (step2C) is only required when sheer is not None
  const needsStep2C = step2B !== "None";

  // Info text vs panel grid: empty Step2A/2B must show the message, not the options
  const showPanelTypeInfo =
    step2A === "" ||
    step2B === "" ||
    widthCart === undefined ||
    step5 === "" ||
    step3A0 === "" ||
    (needsStep2C && step2C === "");
  const showPanelTypeGrid =
    step2A !== "" &&
    step2B !== "" &&
    widthCart !== undefined &&
    step5 !== "" &&
    (!needsStep2C || step2C !== "");

  let panelTypeInfoText;
  if (step2A === "") {
    panelTypeInfoText = t("panel_type_text1_new");
  } else if (step2B === "") {
    panelTypeInfoText = t("panel_type_text1_new_step2B");
  } else if (needsStep2C && step2C === "") {
    panelTypeInfoText = t("panel_type_text1_new_step2C");
  } else if (widthCart === undefined && step5 === "" && step3A0 === "") {
    panelTypeInfoText = t("panel_type_text1");
  } else if (widthCart === undefined && step5 !== "" && step3A0 === "") {
    panelTypeInfoText = t("panel_type_text2");
  } else if (widthCart === undefined && step5 !== "" && step3A0 !== "") {
    panelTypeInfoText = t("panel_type_text3");
  } else if (widthCart === undefined && step5 === "" && step3A0 !== "") {
    panelTypeInfoText = t("panel_type_text4");
  }else if (step5 === "") {
    panelTypeInfoText = t("panel_type_text5");
  }

  return (
    <Card>
      <Card.Header>
        <ContextAwareToggle
          eventKey="6"
          stepNum={step5 === "Full" && step3 === "false" ? t("7") : t("8")}
          stepTitle={t("grommet_step6_Drapery")}
          stepRef="6"
          type="1"
          required={requiredStep["6"]}
          stepSelected={stepSelectedLabel["6"] === undefined ? "" : stepSelectedLabel["6"]}
        />
      </Card.Header>
      <Accordion.Collapse eventKey="6">
        <Card.Body>
          <div className={showPanelTypeInfo ? "card_body card_body_info" : "noDisplay"}>
            <div className="card_body_info_header">
              <h1 className="card_body_info_header_title">{t("more_info")}</h1>
            </div>
            <hr />
            <div className="card_body_info_body">
              <p className="card_body_info_text">{panelTypeInfoText}</p>
            </div>
            <NextStep currentStep="6" eventKey="8">
              {t("NEXT STEP")}
            </NextStep>
          </div>
          <div
            className={
              showPanelTypeGrid ? "card_body_panel_type special_farsi_card_body" : "noDisplay"
            }
          >
            {/* drapery panel type */}
            <div className="card_body card_body_radio Customize_Style_container">
            {parseInt(windowWidthPanelType) > 160  && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text checkBoxPanelType">{t("title_step8_panel_type")}</span>
                      </div>
                    )}
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title">{t("Drapery Panel Type")}</p>
                <div className={isShow ? "grommet_curtain_button_container grommet_curtain_button_container_separated" : "noDisplay"}>
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn
                     ${step6CHead === "Rod" ? "dk_curtain_symmetric_button_on_new" : ""}
                     ${step31 === "Track" ? "crossed" : ""}`}
                      onClick={() => {
                        if (step6CHead === "Rod") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelPLWarning");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Rod Pair, Split Draw";
                            setExtendedTitle(tempExtended);
                          }
                          setPanelPLWarningTemp({
                            stepValue: "Rod",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(3, 1);
                          setExtendedTitle(tempExtended);
                          setStep6CHead("Rod");
                          setStep6C("");

                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6CHead("Rod");
                          setCart("", "", "PanelTypeC");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Rod Pair, Split Draw";
                            tempExtended["6"][2] = "";
                            setExtendedTitle(tempExtended);
                          }
                        }
                      }}
                    >
                      <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6CHead === "Track" ? "dk_curtain_symmetric_button_on_new" : ""
                      } ${tracksList.length > 0 && step2C !== "Grommet" ? "" : ""}
                      ${step31 === "true" ? "crossed" : ""}  
                      ${step31 === "Track" ? "dk_curtain_symmetric_button_on_new" : ""}`}
                      onClick={() => {
                        if (step6CHead === "Track") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelPLWarning");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Track Pair, Split Draw";
                            setExtendedTitle(tempExtended);
                          }
                          setPanelPLWarningTemp({
                            stepValue: "Track",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(2, 1);
                          setExtendedTitle(tempExtended);
                          setStep6CHead("Track");
                          setStep6BHead("Track");
                          setStep6DHead("Track");
                          setStep6C("");

                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6CHead("Track");
                          setStep6BHead("Track");
                          setStep6DHead("Track");
                          setStep6CHead9("Track");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Track Pair, Split Draw";
                            tempExtended["6"][2] = "";
                            setExtendedTitle(tempExtended);
                          }

                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >  <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                 className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  step6CHead === "Rod"
                    ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                      ? "box33 radio_style"
                      : "noDisplay"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                      : require("../../Images/drapery/grommet/panel_type_left.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Single Panel")}
                  value="1"
                  name="step6A"
                  ref-num="6"
                  id="6A1"
                  checked={step6A === "Single Panel"}
                  onChange={(e) => {
                    setStep6A("Single Panel");
                    setStep6("Customize Style Per Curtain");
                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = textDrapery;
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A");
                    setCart("PanelTypeA", "Single Panel");
                  }}
                  ref={(ref) => (inputs.current["6A1"] = ref)}
                />
                <label htmlFor="6A1">{t("Single Panel")}</label>
              </div>
             
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 160
                        ? parseInt(windowWidthPanelType) > 320
                          ? "noDisplay"
                          : "box33 radio_style radio_recommended wide_panel_type"
                        : "box33 radio_style"
                      : "box33 radio_style"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 160 && step6CHead === "Rod"
                        ? pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : require("../../Images/drapery/grommet/panel_type_both.svg").default
                  }
                  className="img-fluid"
                  style={{ height: "13.875rem" }}
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Pair, Split Draw")}
                  value="5"
                  name="step6A"
                  ref-num="6"
                  id="6A5"
                  checked={step6A === "Pair, Split Draw"}
                  onChange={(e) => {
                    setStep6A("Pair, Split Draw");

                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = textDrapery3;
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A");
                    setCart("PanelTypeA", "Pair, Split Draw");
                    if (step5 === "Full" && parseInt(windowWidthPanelType) > 320) {
                      modalHandleShow("panelTypeWarning");
                    }
                  }}
                  ref={(ref) => (inputs.current["6A5"] = ref)}
                />
                <label htmlFor="6A5">{t("Pair, Split Draw")}</label>
              
              </div>
              </div>
              <div
                className={parseInt(windowWidthPanelType) > 320 ? "box100" : "noDisplay"}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                      : require("../../Images/drapery/grommet/panel_type_four.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Four Panel, Split Draw")}
                  value="6"
                  name="step6A"
                  ref-num="6"
                  id="6A7"
                  checked={step6A === "Four Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6A("Four Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = t("Drapery Four Panel, Split Draw");
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A");
                    setCart("PanelTypeA", "Four Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6A7"] = ref)}
                />
                <label htmlFor="6A7">{t("Four Panel, Split Draw")}</label>
              
              </div>
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                      : require("../../Images/drapery/grommet/panel_type_three.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Three Panel, Split Draw")}
                  value="6"
                  name="step6A"
                  ref-num="6"
                  id="6A6"
                  checked={step6A === "Three Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6A("Three Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = t("Drapery Three Panel, Split Draw");
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A");
                    setCart("PanelTypeA", "Three Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6A6"] = ref)}
                />
                <label htmlFor="6A6">{t("Three Panel, Split Draw")}</label>
              
              </div>
              </div>
            </div>
            {/* sheer panel type */}
            <div className="card_body card_body_radio Customize_Style_container" style={{padding: "0 0.4rem"}}>
              <div className="box100">
                <p className="step_selection_title" style={{marginTop: "1.05rem"}}>{t("Sheer Panel Type")}</p>
                <div className={isShow ? "grommet_curtain_button_container grommet_curtain_button_container_separated" : "noDisplay"}>
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn 
                      ${step6CHead === "Track" ? "crossed" : ""}
                      ${step6BHead === "Rod" ? "dk_curtain_symmetric_button_on" : ""} `}
                      onClick={() => {
                        if (step6BHead === "Rod") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Rod",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setStep6DHead("Rod");
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(1, 2);
                          setExtendedTitle(tempExtended);
                          setStep6BHead("Rod");
                          setStep6B("");
                          setCart(
                            "",
                            "",
                            "PanelTypeB,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          let tempExtended = extendedTitle;
                          tempExtended["6"][1] = [];
                          setExtendedTitle(tempExtended);
                          setStep6BHead("Rod");
                          setStep6B("");
                          setCart("", "", "PanelTypeB");
                        }
                      }}
                    >
                      <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6BHead === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      }`}
                      onClick={() => {
                        if (step6BHead === "Track") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Track",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep6DHead("Track");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(2, 1);
                          setExtendedTitle(tempExtended);
                          setStep6BHead("Track");
                          setStep6B("");

                          setCart(
                            "",
                            "",
                            "PanelTypeB,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6DHead("Track");
                          setStep6BHead("Track");
                          setStep6B("");
                          if (step6C === "Pair, Split Draw") {
                            setStep6C("");
                          }

                          setCart("", "", "PanelTypeB");
                        }
                      }}
                    >
                      <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                 className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  parseInt(windowWidthPanelType) > 160
                    ? step6BHead === "Track"
                      ? step6BHead === "Rod"
                        ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                          ? "box33 radio_style"
                          : "noDisplay"
                        : "box33 radio_style"
                      : "noDisplay"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                      : require("../../Images/drapery/grommet/panel_type_left.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Single Panel")}
                  value="1"
                  name="step6B"
                  ref-num="6"
                  id="6B1"
                  checked={step6B === "Single Panel"}
                  onChange={(e) => {
                    setStep6B("Single Panel");
                    if (step2B === "None") {
                      setDeps("", "6B,6C");
                    } else {
                      setDeps("", "6B,6");
                    }
                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Sheer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">{textSheer}</span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);

                    setCart("PanelTypeB", "Single Panel");
                    //     selectChanged(e ,2);
                  }}
                  ref={(ref) => (inputs.current["6B1"] = ref)}
                />
                <label htmlFor="6B1">{t("Single Panel")}</label>
              </div>
             
              <div
                className={
                  step6BHead === "Rod"
                    ? step5 !== ""
                      ? parseInt(windowWidthPanelType) > 160
                        ? parseInt(windowWidthPanelType) > 320
                          ? "noDisplay"
                          : "box33 radio_style radio_recommended wide_panel_type"
                        : "box33 radio_style"
                      : "box33 radio_style"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    step5 !== ""
                      ? parseInt(windowWidthPanelType) > 160 && step6BHead === "Rod"
                        ? pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : require("../../Images/drapery/grommet/panel_type_both.svg").default
                  }
                  className="img-fluid"
                  style={{ height: "13.875rem" }}
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Pair, Split Draw")}
                  value="5"
                  name="step6B"
                  ref-num="6"
                  id="6B5"
                  checked={step6B === "Pair, Split Draw"}
                  onChange={(e) => {
                    setStep6B("Pair, Split Draw");
                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Sheer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">{textSheer3}</span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    if (step2B === "None") {
                      setDeps("", "6B,6C");
                    } else {
                      setDeps("", "6B,6");
                    }
                    setCart("PanelTypeB", "Pair, Split Draw");
                    //   selectChanged(e);
                    if (step5 === "Full" && parseInt(windowWidthPanelType) > 320 && step6BHead === "Rod") {
                      modalHandleShow("panelTypeWarning");
                    }
                  }}
                  ref={(ref) => (inputs.current["6B5"] = ref)}
                />
                <label htmlFor="6B5">{t("Pair, Split Draw")}</label>
            
              </div>
              </div> 
              <div
                className={parseInt(windowWidthPanelType) > 320 ? "box100" : "noDisplay"}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                }}
              >
               <div
                className={
                  step6BHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                      : require("../../Images/drapery/grommet/panel_type_four.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Four Panel, Split Draw")}
                  value="6"
                  name="step6B"
                  ref-num="6"
                  id="6B7"
                  checked={step6B === "Four Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6B("Four Panel, Split Draw");
                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Sheer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {t("Four Panel, Split Draw")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    if (step2B === "None") {
                      setDeps("", "6B,6C");
                    } else {
                      setDeps("", "6B,6");
                    }
                    setCart("PanelTypeB", "Four Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6B7"] = ref)}
                />
                <label htmlFor="6B7">{t("Four Panel, Split Draw")}</label>
               
              </div>
              <div
                className={
                  step6BHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                      : require("../../Images/drapery/grommet/panel_type_three.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Three Panel, Split Draw")}
                  value="6"
                  name="step6B"
                  ref-num="6"
                  id="6B6"
                  checked={step6B === "Three Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6B("Three Panel, Split Draw");
                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Sheer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {t("Three Panel, Split Draw")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    if (step2B === "None") {
                      setDeps("", "6B,6C");
                    } else {
                      setDeps("", "6B,6");
                    }
                    setCart("PanelTypeB", "Three Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6B6"] = ref)}
                />
                <label htmlFor="6B6">{t("Three Panel, Split Draw")}</label>
               
              </div>
              </div>
              
             
              {step2B === "None" && (
                <NextStep currentStep="6" eventKey="8">
                  {t("NEXT STEP")}
                </NextStep>
              )}
            </div>
            {/* privacy layer panel type */}
            <div
              className={
                needsStep2C && step2C !== ""
                  ? "card_body card_body_radio Customize_Style_container"
                  : "noDisplay"
              }
            >
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title">{t("Privacy Layer Panel Type")}</p>
                <div className={isShow ? "grommet_curtain_button_container grommet_curtain_button_container_separated" : "noDisplay"}>
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn
                      ${step6BHead === "Track" ? "crossed" : ""}
                      ${step6DHead === "Rod" ? "dk_curtain_symmetric_button_on" : ""} 
                    `}
                      onClick={() => {
                        if (step6DHead === "Rod") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Rod",
                            id: "1",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(3, 1);
                          setExtendedTitle(tempExtended);
                          setStep6DHead("Rod");
                          setStep6C("");
                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6DHead("Rod");
                          setStep6C("");
                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >
                       <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6DHead === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      } ${tracksList2.length > 0 && step2C !== "Grommet" ? "" : "crossed"}`}
                      onClick={() => {
                        if (step6DHead === "Track") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Track",
                            id: "1",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(3, 1);
                          setExtendedTitle(tempExtended);
                          setStep6DHead("Track");
                          setStep6C("");
                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6DHead("Track");
                          setStep6C("");
                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >
                       <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
               className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  parseInt(windowWidthPanelType) > 160
                    ? step6DHead === "Track"
                      ? step6DHead === "Rod"
                        ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                          ? "box33 radio_style"
                          : "noDisplay"
                        : "box33 radio_style"
                      : "noDisplay"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                      : require("../../Images/drapery/grommet/panel_type_left.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Single Panel")}
                  value="1"
                  name="step6C"
                  ref-num="6"
                  id="6C1"
                  checked={step6C === "Single Panel"}
                  onChange={(e) => {
                    setStep6C("Single Panel");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][2] = (
                      <li key="2" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">{textLayer}</span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6C,6");
                    setCart("PanelTypeC", "Single Panel");
                    //   selectChanged(e);
                  }}
                  ref={(ref) => (inputs.current["6C1"] = ref)}
                />
                <label htmlFor="6C1">{t("Single Panel")}</label>
              </div>
           
              <div
                className={
                  step6DHead === "Rod"
                    ? step5 !== ""
                      ? parseInt(windowWidthPanelType) > 160
                        ? parseInt(windowWidthPanelType) > 320
                          ? "noDisplay"
                          : "box33 radio_style radio_recommended wide_panel_type"
                        : "box33 radio_style"
                      : "box33 radio_style"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    step5 !== ""
                      ? parseInt(windowWidthPanelType) > 160 && step6DHead === "Rod"
                        ? pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panelType.svg").default
                          : require("../../Images/drapery/grommet/panelType.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : require("../../Images/drapery/grommet/panel_type_both.svg").default
                  }
                  className="img-fluid"
                  style={{ height: "13.875rem" }}
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Pair, Split Draw")}
                  value="5"
                  name="step6C"
                  ref-num="6"
                  id="6C5"
                  checked={step6C === "Pair, Split Draw"}
                  onChange={(e) => {
                    setStep6C("Pair, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][2] = (
                      <li key="2" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">{textLayer3}</span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6C,6");
                    setCart("PanelTypeC", "Pair, Split Draw");
                    //     selectChanged(e);
                    if (step5 === "Full" && parseInt(windowWidthPanelType) > 320 && step6CHead === "Rod") {
                      modalHandleShow("panelTypeWarning");
                    }
                  }}
                  ref={(ref) => (inputs.current["6C5"] = ref)}
                />
                <label htmlFor="6C5">{t("Pair, Split Draw")}</label>
               
              </div>
              </div>
              <div
                className={parseInt(windowWidthPanelType) > 320 ? "box100" : "noDisplay"}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                }}
              >
               <div
                className={
                  step6DHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                      : require("../../Images/drapery/grommet/panel_type_four.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Four Panel, Split Draw")}
                  value="6"
                  name="step6C"
                  ref-num="6"
                  id="6C7"
                  checked={step6C === "Four Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6C("Four Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][2] = (
                      <li key="2" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {t("Four Panel, Split Draw")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6C,6");
                    setCart("PanelTypeC", "Four Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6C7"] = ref)}  
                />
                <label htmlFor="6C7">{t("Four Panel, Split Draw")}</label>
               
              </div>
              <div
                className={
                  step6DHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                      : require("../../Images/drapery/grommet/panel_type_three.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Three Panel, Split Draw")}
                  value="6"
                  name="step6C"
                  ref-num="6"
                  id="6C6"
                  checked={step6C === "Three Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6C("Three Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][2] = (
                      <li key="2" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer Panel")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {t("Three Panel, Split Draw")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6C,6");
                    setCart("PanelTypeC", "Three Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6C6"] = ref)}
                />
                <label htmlFor="6C6">{t("Three Panel, Split Draw")}</label>
              </div>
              </div> 
             
              <NextStep currentStep="6" eventKey="8">
                {t("NEXT STEP")}
              </NextStep>
            </div>
            <div
              className={
                needsStep2C && step2C === ""
                  ? "card_body card_body_radio Customize_Style_container"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">{t("Privacy Layer Panel Type")}</p>
              </div>
              <div className="checkbox_text_info_container">
                <div className="card-body-display-flex">
                  <span className="checkbox_text">{t("pl_hs_incomplete")}</span>
                </div>
              </div>
              <NextStep currentStep="6" eventKey="8">
                {t("NEXT STEP")}
              </NextStep>
            </div>
          </div>
          {showPanelTypeGrid && (
            <div className="accordion_help">
              <div className={`help_container ${pageLanguage === "fa" ? "help_container_fa" : ""}`}>
                <div className="help_column help_left_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_1")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step61"] === undefined
                                        ? require("../../Images/drapery/grommet/single_panel.jpg")
                                        : popoverImages["step61"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_1")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/single_panel.jpg")}
                                        text="step61"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_2")}
                    </li>
                    <li>{t("grommet_panel_type_help_3")}</li>
                  </ul>
                </div>
                <div className="help_column help_right_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_4")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step52"] === undefined
                                        ? require("../../Images/drapery/grommet/pair_panel.jpg")
                                        : popoverImages["step52"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_6")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/pair_panel.jpg")}
                                        text="step52"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_6")}
                    </li>
                    <li>{t("grommet_panel_type_help_7")}</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
